import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserIcon, MailIcon, LockIcon, PhoneIcon } from 'lucide-react';
const RegisterPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    agreeTerms: false
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Clear error when field is edited
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = {
          ...prev
        };
        delete newErrors[name];
        return newErrors;
      });
    }
  };
  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.email.trim()) newErrors.email = 'Email is required';else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email is invalid';
    if (!formData.phone.trim()) newErrors.phone = 'Phone number is required';
    if (!formData.password) newErrors.password = 'Password is required';else if (formData.password.length < 8) newErrors.password = 'Password must be at least 8 characters';
    if (!formData.confirmPassword) newErrors.confirmPassword = 'Please confirm your password';else if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
    if (!formData.agreeTerms) newErrors.agreeTerms = 'You must agree to the terms and conditions';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitting(true);
      // Simulate API call
      setTimeout(() => {
        setIsSubmitting(false);
        // In a real app, you'd create the user account and handle authentication
        navigate('/dashboard');
      }, 1000);
    }
  };
  return <div className="bg-gray-50 min-h-screen w-full flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-966">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-967">
        <h2 className="mt-6 text-center text-3xl font-bold text-gray-900" data-id="element-968">
          Create your account
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-969">
          Already have an account?{' '}
          <Link to="/login" className="font-medium text-blue-600 hover:text-blue-500" data-id="element-970">
            Sign in
          </Link>
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-971">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-972">
          <form className="space-y-6" onSubmit={handleSubmit} data-id="element-973">
            <div data-id="element-974">
              <label htmlFor="name" className="block text-sm font-medium text-gray-700" data-id="element-975">
                Full Name
              </label>
              <div className="mt-1 relative" data-id="element-976">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-977">
                  <UserIcon className="h-5 w-5 text-gray-400" data-id="element-978" />
                </div>
                <input id="name" name="name" type="text" autoComplete="name" value={formData.name} onChange={handleChange} className={`block w-full pl-10 pr-3 py-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${errors.name ? 'border-red-500' : 'border-gray-300'}`} data-id="element-979" />
              </div>
              {errors.name && <p className="mt-2 text-sm text-red-600" data-id="element-980">{errors.name}</p>}
            </div>
            <div data-id="element-981">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-982">
                Email address
              </label>
              <div className="mt-1 relative" data-id="element-983">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-984">
                  <MailIcon className="h-5 w-5 text-gray-400" data-id="element-985" />
                </div>
                <input id="email" name="email" type="email" autoComplete="email" value={formData.email} onChange={handleChange} className={`block w-full pl-10 pr-3 py-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${errors.email ? 'border-red-500' : 'border-gray-300'}`} data-id="element-986" />
              </div>
              {errors.email && <p className="mt-2 text-sm text-red-600" data-id="element-987">{errors.email}</p>}
            </div>
            <div data-id="element-988">
              <label htmlFor="phone" className="block text-sm font-medium text-gray-700" data-id="element-989">
                Phone Number
              </label>
              <div className="mt-1 relative" data-id="element-990">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-991">
                  <PhoneIcon className="h-5 w-5 text-gray-400" data-id="element-992" />
                </div>
                <input id="phone" name="phone" type="tel" autoComplete="tel" value={formData.phone} onChange={handleChange} className={`block w-full pl-10 pr-3 py-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${errors.phone ? 'border-red-500' : 'border-gray-300'}`} data-id="element-993" />
              </div>
              {errors.phone && <p className="mt-2 text-sm text-red-600" data-id="element-994">{errors.phone}</p>}
            </div>
            <div data-id="element-995">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-996">
                Password
              </label>
              <div className="mt-1 relative" data-id="element-997">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-998">
                  <LockIcon className="h-5 w-5 text-gray-400" data-id="element-999" />
                </div>
                <input id="password" name="password" type="password" autoComplete="new-password" value={formData.password} onChange={handleChange} className={`block w-full pl-10 pr-3 py-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${errors.password ? 'border-red-500' : 'border-gray-300'}`} data-id="element-1000" />
              </div>
              {errors.password && <p className="mt-2 text-sm text-red-600" data-id="element-1001">{errors.password}</p>}
            </div>
            <div data-id="element-1002">
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700" data-id="element-1003">
                Confirm Password
              </label>
              <div className="mt-1 relative" data-id="element-1004">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1005">
                  <LockIcon className="h-5 w-5 text-gray-400" data-id="element-1006" />
                </div>
                <input id="confirmPassword" name="confirmPassword" type="password" autoComplete="new-password" value={formData.confirmPassword} onChange={handleChange} className={`block w-full pl-10 pr-3 py-2 border rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm ${errors.confirmPassword ? 'border-red-500' : 'border-gray-300'}`} data-id="element-1007" />
              </div>
              {errors.confirmPassword && <p className="mt-2 text-sm text-red-600" data-id="element-1008">
                  {errors.confirmPassword}
                </p>}
            </div>
            <div className="flex items-center" data-id="element-1009">
              <input id="agreeTerms" name="agreeTerms" type="checkbox" checked={formData.agreeTerms} onChange={handleChange} className={`h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded ${errors.agreeTerms ? 'border-red-500' : ''}`} data-id="element-1010" />
              <label htmlFor="agreeTerms" className="ml-2 block text-sm text-gray-900" data-id="element-1011">
                I agree to the{' '}
                <a href="#" className="font-medium text-blue-600 hover:text-blue-500" data-id="element-1012">
                  Terms and Conditions
                </a>{' '}
                and{' '}
                <a href="#" className="font-medium text-blue-600 hover:text-blue-500" data-id="element-1013">
                  Privacy Policy
                </a>
              </label>
            </div>
            {errors.agreeTerms && <p className="mt-2 text-sm text-red-600" data-id="element-1014">{errors.agreeTerms}</p>}
            <div data-id="element-1015">
              <button type="submit" disabled={isSubmitting} className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500'}`} data-id="element-1016">
                {isSubmitting ? 'Creating Account...' : 'Create Account'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>;
};
export default RegisterPage;